
<block-ui>
  @if (!loading) {
    <ng-container class="trans-overlay">
      <span id="main-router-outlet"><router-outlet></router-outlet></span>
    </ng-container>
  }
</block-ui>
